"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.People = void 0;
const base_1 = require("../../base");
const Faces_1 = require("./Faces");
exports.People = {
    Faces: Faces_1.Faces,
    create: (0, base_1.declare)({
        method: 'post',
        path: '/workspaces/:workspaceId/people',
    }).as(),
    delete: (0, base_1.declare)({
        method: 'delete',
        path: '/workspaces/:workspaceId/people/:personId',
    }).as(),
    search: (0, base_1.declare)({
        method: 'post',
        path: '/workspaces/:workspaceId/people/search',
    }).as(),
    get: (0, base_1.declare)({
        method: 'get',
        path: '/workspaces/:workspaceId/people/:personId',
    }).as(),
    update: (0, base_1.declare)({
        method: 'patch',
        path: '/workspaces/:workspaceId/people/:personId',
    }).as(),
};
//# sourceMappingURL=index.js.map